import { IconProps } from './types';

// eslint-disable-next-line @typescript-eslint/no-magic-numbers
export function ClockFilled({ size = 18, ...props }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.4987 1.33301C4.82536 1.33301 1.83203 4.32634 1.83203 7.99967C1.83203 11.673 4.82536 14.6663 8.4987 14.6663C12.172 14.6663 15.1654 11.673 15.1654 7.99967C15.1654 4.32634 12.172 1.33301 8.4987 1.33301ZM11.3987 10.3797C11.3054 10.5397 11.1387 10.6263 10.9654 10.6263C10.8787 10.6263 10.792 10.6063 10.712 10.553L8.64536 9.31967C8.13203 9.01301 7.75203 8.33967 7.75203 7.74634V5.01301C7.75203 4.73967 7.9787 4.51301 8.25203 4.51301C8.52536 4.51301 8.75203 4.73967 8.75203 5.01301V7.74634C8.75203 7.98634 8.95203 8.33967 9.1587 8.45967L11.2254 9.69301C11.4654 9.83301 11.5454 10.1397 11.3987 10.3797Z"
        fill="currentColor"
      />
    </svg>
  );
}
